import React, { useState } from "react";
import Search from "../include/Search";
import HealthCheckup from "./partials/HealthCheckup";
import "./HealthCheckupList.css";

const HealthCheckupList = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="health-list-section">
        <Search onSearch={(value) => setSearch(value)} />
        <HealthCheckup search={search} />
    </div>
  );
};

export default HealthCheckupList;
